export function appRoutes($stateProvider, $urlRouterProvider) {
    $stateProvider
        .state('no-route', {
            url: '/noRoute',
            templateUrl: 'app/shared/no-route.html'
        })
        .state('accessDenied', {
            url: '/accessDenied',
            template: `<access-denied></access-denied>`
        });

    $urlRouterProvider.otherwise('/noRoute');
}

appRoutes.$inject = ['$stateProvider', '$urlRouterProvider'];